import { render, staticRenderFns } from "./fieldManage.vue?vue&type=template&id=4ba5c8a0&scoped=true&"
import script from "./fieldManage.vue?vue&type=script&lang=js&"
export * from "./fieldManage.vue?vue&type=script&lang=js&"
import style0 from "./fieldManage.vue?vue&type=style&index=0&id=4ba5c8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5c8a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba5c8a0')) {
      api.createRecord('4ba5c8a0', component.options)
    } else {
      api.reload('4ba5c8a0', component.options)
    }
    module.hot.accept("./fieldManage.vue?vue&type=template&id=4ba5c8a0&scoped=true&", function () {
      api.rerender('4ba5c8a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/setting/fieldManage.vue"
export default component.exports